export default "__VITE_ASSET__oOlEvGyP__"